import { all, put, call } from 'redux-saga/effects';
import * as API from '../../services/api';
import actionTypes from '../actionTypes';
import { checkToken } from './check';

export function* getProfile() {
  try {
    const data = yield call(API.getProfile);

    if (data.id) {
      yield put({ type: actionTypes.PROFILE_GET_SUCCESS, data });
    } else {
      yield all([
        put(checkToken(data.error)),
        put({ type: actionTypes.PROFILE_GET_ERROR, error: data.error }),
      ]);
    }
  } catch (error) {
    yield put({ type: actionTypes.PROFILE_GET_ERROR, error });
  }
}

export function* updateProfile({ profile }) {
  try {
    const result = yield call(API.updateProfile, profile);
    if (result.error) {
      yield put({
        type: actionTypes.PROFILE_UPDATE_ERROR,
        error: result.error,
      });
    } else {
      yield put({ type: actionTypes.PROFILE_UPDATE_SUCCESS, data: result });
    }
  } catch (error) {
    yield put({ type: actionTypes.PROFILE_UPDATE_ERROR, error });
  }
}

export function* verifyPhone({ data }) {
  try {
    const result = yield call(API.verifyPhone, data);
    if (result.success) {
      yield put({
        type: actionTypes.PHONE_VERIFY_SUCCESS,
        message: result.message,
      });
    } else {
      yield put({
        type: actionTypes.PHONE_VERIFY_ERROR,
        message: result.message,
      });
    }
  } catch (error) {
    yield put({ type: actionTypes.PHONE_VERIFY_ERROR, message: error.message });
  }
}

export function* checkPhoneVerify({ data }) {
  try {
    const result = yield call(API.checkPhoneVerify, data);
    if (result.success) {
      yield put({
        type: actionTypes.PHONE_VERIFY_CHECK_SUCCESS,
        message: result.message,
      });
    } else {
      yield put({
        type: actionTypes.PHONE_VERIFY_CHECK_ERROR,
        message: result.message,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.PHONE_VERIFY_CHECK_ERROR,
      message: error.message,
    });
  }
}

export function* changePassword({ data }) {
  try {
    const result = yield call(API.changePassword, data);
    if (result.error) {
      yield put({
        type: actionTypes.PASSWORD_CHANGE_ERROR,
        error: result.error,
      });
    } else {
      yield put({ type: actionTypes.PASSWORD_CHANGE_SUCCESS, result });
    }
  } catch (error) {
    yield put({ type: actionTypes.PASSWORD_CHANGE_ERROR, error });
  }
}

export function* getMarketingContent({ userId }) {
  try {
    const result = yield call(API.getMarketingContent, userId);
    if (result.error) {
      yield put({
        type: actionTypes.GET_MARKETING_CONTENT_ERROR,
        error: result.error,
      });
    } else {
      yield put({ type: actionTypes.GET_MARKETING_CONTENT_SUCCESS, result });
    }
  } catch (error) {
    yield put({ type: actionTypes.GET_MARKETING_CONTENT_ERROR, error });
  }
}

export function* createMarketingContent({ data }) {
  try {
    const result = yield call(API.createMarketingContent, data);
    if (result.error) {
      yield put({
        type: actionTypes.CREATE_MARKETING_CONTENT_ERROR,
        error: result.error,
      });
    } else {
      yield put({ type: actionTypes.CREATE_MARKETING_CONTENT_SUCCESS, result });
    }
  } catch (error) {
    yield put({ type: actionTypes.CREATE_MARKETING_CONTENT_ERROR, error });
  }
}

export function* updateMarketingContent({ data }) {
  try {
    const result = yield call(API.updateMarketingContent, data);
    if (result.error) {
      yield put({
        type: actionTypes.UPDATE_MARKETING_CONTENT_ERROR,
        error: result.error,
      });
    } else {
      yield put({ type: actionTypes.UPDATE_MARKETING_CONTENT_SUCCESS, result });
    }
  } catch (error) {
    yield put({ type: actionTypes.UPDATE_MARKETING_CONTENT_ERROR, error });
  }
}

export function* fixAgreementInviteIssue({ data }) {
  try {
    const result = yield call(API.fixAgreementInviteIssue, data);
    if (result.error) {
      yield put({
        type: actionTypes.FIX_AGREEMENT_INVITE_ISSUE_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.FIX_AGREEMENT_INVITE_ISSUE_SUCCESS,
        result,
      });
    }
  } catch (error) {
    yield put({ type: actionTypes.FIX_AGREEMENT_INVITE_ISSUE_ERROR, error });
  }
}



// WEBPACK FOOTER //
// src/redux/sagas/profile.js